import React from 'react';
import '../styles/config-text-middle.scss';
import { NumpadIconFive } from './config-numpad-five';
import { NumpadIcon } from './config-numpad';

interface Props {
    textLeft: string;
    textRight: string;
}

export const ConfigTextMiddle: React.FunctionComponent<Props> = props => {
    return (
        <div className='config-text-middle--wrapper'>
            <div className={'config-text-middle__box__left'}>
                <div className={'standard-text config-text-middle__left'}>{props.textLeft}</div>
                <NumpadIcon />
            </div>
            <div className={'config-text-middle__box__right'}>
                <div className={'standard-text config-text-middle__right'}>{props.textRight}<NumpadIconFive/></div>
            </div>
        </div >
    );
};

